module.exports = __webpack_public_path__ + "static/img/yjjl.e4e05a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yjjl.png
// module id = Hxyx
// module chunks = 0